export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        
      },
      "fr": {
        "access_manager": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accès manager"])},
        "dashboard": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tableau de bord"])},
        "licenses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Licences"])},
        "my_prospects": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mes prospects"])},
        "my_prospecting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ma prospection"])},
        "prospecting_list": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Liste de prospection"])},
        "smart_scoring": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Smart Scoring"])},
        "team_follow_up": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suivi d'équipe"])}
      }
    }
  })
}
